import React from 'react';
import { Controller, FieldPath, FieldValues, RegisterOptions, useFormContext } from 'react-hook-form';
import { FileInput } from '@clarke-energia/foton-v2';
import { get } from 'lodash';

export interface FileFieldProps<T extends FieldValues> {
  field: FieldPath<T>;
  label: string;
  onChangeFiles: (files: File) => void;
  placeholder?: string;
  id: string;
  options?: RegisterOptions<T>;
  description: string;
  maximumFileSizeInMB: number;
  allowedFileTypes?: string[];
  multipleFiles?: boolean;
  storedFiles?: Array<any>;
  handleRemoveStoredFile?: (fileId: string) => void;
  loading?: boolean;
}

export function FileFieldV2<T extends FieldValues>({
  field,
  label,
  id,
  placeholder,
  options,
  description,
  maximumFileSizeInMB,
  multipleFiles,
  allowedFileTypes,
  storedFiles,
  handleRemoveStoredFile,
  loading,
  onChangeFiles,
}: FileFieldProps<T>) {
  const {
    control,
    formState: { errors },
  } = useFormContext<T>();
  const formError = get(errors, field)?.message as string | undefined;
  return (
    <Controller
      control={control}
      name={field}
      rules={options}
      render={({ field: { name, onBlur, value, onChange } }) => (
        <div id={id} className="flex flex-col col-span-1 !h-fit">
          <FileInput
            name={name}
            label={label}
            value={value}
            className="rounded-2xl border-2 border-dashed border-gray-20"
            allowedFileTypes={allowedFileTypes}
            placeholder={placeholder}
            required={(options?.required as boolean) || false}
            onBlur={onBlur}
            onChangeFiles={(file) => {
              onChange(file);
              onChangeFiles(file as File);
            }}
            description={description}
            maximumFileSizeInMB={maximumFileSizeInMB}
            multipleFiles={multipleFiles}
            storedFiles={storedFiles}
            handleRemoveStoredFile={handleRemoveStoredFile}
            loading={loading}
            customAttrs={{ 'data-cy': id }}
          />
          {formError && (
            <span className="text-red-500 text-sm mt-1" data-cy={`${id}-error`}>
              {formError}
            </span>
          )}
        </div>
      )}
    />
  );
}
